import { Stack } from "@mantine/core";
import type React from "react";

type Props = {
	children: React.ReactNode;
};

export const FormLayout = ({ children }: Props) => {
	return (
		<Stack
			miw={448}
			bg="gray.0"
			px={64}
			py={56}
			gap="lg"
			style={{ borderRadius: "8px" }}
		>
			{children}
		</Stack>
	);
};
